<template>
  <div class="accordion stihl-accordion">
    <div class="accordion-item" v-for="opt in options" :key="opt.key">

      <h2
        class="accordion-header"
        :aria-expanded="!opt.initClosed"
        aria-controls="'acItem_' + id + '_'+opt">
        <slot :name="`header-${opt.key}`" />
        <button
          class="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="`#acItem_${id}_${opt.key}`">
          {{ opt.header }}
        </button>
      </h2>

      <div
        :id="`acItem_${id}_${opt.key}`"
        class="accordion-collapse collapse show"
        :data-bs-parent="stayOpen ? '' : `#${id}`">
        <div class="accordion-body">
          <slot :name="opt.key" />
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export interface AccordionItem {
  key: string;
  header: string;
  initClosed?: boolean;
}

export default defineComponent({
  name: 'StihlAccordion',
  props: {
    options: { type: Array as PropType<AccordionItem[]>, required: true },
    stayOpen: { type: Boolean, default: true }, // if false -> only 1 item can stays open
  },
  computed: {
    id(): string {
      return this.$.uid.toString();
    },
  },
});
</script>

<style>
.accordion.stihl-accordion {
  width: 100%;
  --bs-accordion-bg: transparent;
}

.stihl-accordion .accordion-header {
  display: flex;
  gap: .5rem;
  align-items: center;
  border-bottom: 1px solid var(--grey-mid);

  padding: 1.5rem 1.25rem 1rem;
}

.stihl-accordion .accordion-item {
  border: 0;
}

.stihl-accordion .accordion-button {
  background-color: transparent;
  color: var(--grey-deep);
  font-feature-settings: 'clig' off, 'liga' off;
  /* hl-desktop/h3 */
  font-family: var(--stihl-font-family-text);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 120% */

  --bs-accordion-btn-padding-y: 0;
  --bs-accordion-btn-padding-x: 0;
}

.stihl-accordion .accordion-button:not(.collapsed) {
  border: 0;
  background-color: transparent;
  color: var(--grey-deep);
  box-shadow: none;
}

.stihl-accordion .accordion-body {
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-padding-x: 1.25rem;
}
</style>
